import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import { UpdateSegmentForm } from './update-segment-form.tsx';
import type { SegmentSegmentCollectionReadModel } from '@r/api/generated/client.schemas.ts';

type Segment = SegmentSegmentCollectionReadModel;

interface UpdateSegmentDialogProps {
  segment: Segment | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

/** Modale de modification d'un segment existant. */
export const UpdateSegmentDialog: FC<UpdateSegmentDialogProps> = ({
  segment,
  isOpen,
  onOpenChange,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('admin.segments.update.dialog.title')}</DialogTitle>
          <DialogDescription>{t('admin.segments.update.dialog.description')}</DialogDescription>
        </DialogHeader>

        {isOpen && segment && <UpdateSegmentForm segment={segment} onSuccess={handleSuccess} />}
      </DialogContent>
    </Dialog>
  );
};
